import wsaroutes from "app/wsa/wsaroutes";

const dashboardroutes = [...wsaroutes];

export default dashboardroutes;
